<div class="col-auto p-0" style="display:flex;">
    <div class="dropdown mr-16 display-inline-flex">
        <input type="date" [(ngModel)]="startDate" (change)="onDateChange()">
    </div>
    <div class="dropdown display-inline-flex">
        <input type="date" [(ngModel)]="endDate" (change)="onDateChange()">
    </div>
</div>